
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
	$locationProvider.html5Mode(true)

  	$stateProvider
    .state('app.minorHalf', {
            abstract: false,
            url: '/course-front/sala-cuna-menor',
            template: require('./minor-half/view/minorHalf.html'),
            controller: 'minorHalfController',
            controllerAs:'minorHalf'
	})
	.state('app.olderNursery', {
		abstract: false,
		url: '/course-front/sala-cuna-mayor',
		template: require('./older-nursery/view/olderNursery.html'),
		controller: 'olderNurseryController',
		controllerAs:'olderNursery'
	})
	.state('app.middleMinor', {
		abstract: false,
		url: '/course-front/medio-menor',
		template: require('./middle-minor/view/middleMinor.html'),
		controller: 'middleMinorController',
		controllerAs:'middleMinor'
	})
	.state('app.middleMajor', {
		abstract: false,
		url: '/course-front/medio-mayor',
		template: require('./middle-major/view/middleMajor.html'),
		controller: 'middleMajorController',
		controllerAs:'middleMajor'
	})
	.state('app.transitionOne', {
		abstract: false,
		url: '/course-front/transicion-uno',
		template: require('./transition-one/view/transitionOne.html'),
		controller: 'transitionOneController',
		controllerAs:'transitionOne'
	})
	.state('app.transitionDos', {
		abstract: false,
		url: '/course-front/transicion-dos',
		template: require('./transition-dos/view/transitionDos.html'),
		controller: 'transitionDosController',
		controllerAs:'transitionDos'
	})
}



// WEBPACK FOOTER //
// ./src/app/course-front/courseFront.route.js